export default __webpack_public_path__ + "static/media/community.4afdc99b.svg";